<div class="padding">
  <div class="flex-container">
    <h1 class="left-box">{{ 'common.labels.invoiceDetails' | transloco }}</h1>
    <span class="spacer"></span>
    @if (invoice?.detailsDocument) {
      <lib-document-download
        [documentID]="invoice!.detailsDocument!.id"
        [documentName]="'common.labels.invoiceDetailsDocument' | transloco">
      </lib-document-download>
    }
    @if (invoice?.ordersDocument) {
      <lib-document-download
        [documentID]="invoice!.ordersDocument!.id"
        [documentName]="'common.labels.invoiceOrdersDocument' | transloco">
      </lib-document-download>
    }
  </div>

  <mat-card>
    <mat-card-content>
      <div class="flex-container">
        <span class="flex-item">{{ 'common.labels.invoice' | transloco }}</span><span class="flex-item-2">{{ invoice?.invoiceNumber }}</span>
        <span class="flex-item">{{ 'common.labels.billingCentre2' | transloco }}</span><span class="flex-item-2">{{ billingDetails?.name }}</span>
        <span class="flex-item">{{ 'common.labels.billingCycle2' | transloco }}</span><span class="flex-item-2">{{ invoice?.billingCycle!.name }}</span>
      </div>
      @if (invoice?.invoiceMessage) {
      <div class="flex-container">
        <span class="flex-item">{{ 'common.labels.invoiceMessage' | transloco }}</span><span class="flex-item-2">{{ invoice?.invoiceMessage }}</span>
        <span class="flex-item">&nbsp;</span><a class="flex-item-2">&nbsp;</a>
        <span class="flex-item">&nbsp;</span><span class="flex-item-2">&nbsp;</span>
      </div>
      }
      <mat-divider></mat-divider>
      <div class="flex-container">
        <span class="flex-item">{{ 'common.labels.dateOpened' | transloco }}</span><span class="flex-item-2">{{ $safeNavigationMigration(invoice?.dateOpened) | localizedDate:'yyyy-MM-dd' }}</span>
        <span class="flex-item">{{ 'common.labels.dateClosed' | transloco }}</span><span class="flex-item-2">{{ $safeNavigationMigration(invoice?.dateClosed) | localizedDate:'yyyy-MM-dd' }}</span>
        <span class="flex-item">{{ 'accounting.dateSent' | transloco }}</span><span class="flex-item-2">{{ $safeNavigationMigration(invoice?.dateExported) | localizedDate:'yyyy-MM-dd' }}</span>
      </div>
      <mat-divider></mat-divider>
      <div class="flex-container">
        <span class="flex-item"><b>{{ 'common.labels.subTotal' | transloco }}</b></span><span class="flex-item-2"><b>{{ $safeNavigationMigration(invoice?.subTotal) | currency }}</b></span>
        <span class="flex-item"><b>{{ 'common.labels.tax' | transloco }}</b></span><span class="flex-item-2"><b>{{ $safeNavigationMigration(invoice?.tax) | currency }}</b></span>
        <span class="flex-item"><b>{{ 'common.labels.total' | transloco }}</b></span><span class="flex-item-2"><b>{{ $safeNavigationMigration(invoice?.total) | currency }}</b></span>
      </div>
      <br/>
      <mat-tab-group animationDuration="0ms" [selectedIndex]="selectedIndex">
        <mat-tab [label]="'common.labels.orderFees' | transloco">
          <app-invoice-fees></app-invoice-fees>
        </mat-tab>
        <mat-tab [label]="'common.labels.subscriptionFees' | transloco">
          @if (invoice) {
          <app-subscription-fees-list [invoice]="invoice"></app-subscription-fees-list>
          }
        </mat-tab>
      </mat-tab-group>
    </mat-card-content>
  </mat-card>
</div>